export default __webpack_public_path__ + "static/lifehacks.tik-873da643b1a62662e69387099ce39184.jpg";